import SizedBox from "@components/SizedBox";
import styled from "@emotion/styled";
import React from "react";
import AddLiquidityToRangeAmountSelector from "./AddLiquidityToRangeAmountSelector";
import DepositComposition from "./DepositComposition";
import YourPool from "./YourRange";

interface IProps {}

const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

const AddLiquidityToCustomPool: React.FC<IProps> = () => {
  return (
    <Root>
      <YourPool />
      <SizedBox height={24} />
      <AddLiquidityToRangeAmountSelector />
      <SizedBox height={24} />
      <DepositComposition />
    </Root>
  );
};
export default AddLiquidityToCustomPool;
